<mat-tab-group mat-stretch-tabs (selectedTabChange)="tabChange($event)">
  <mat-tab label="MakeQuest"></mat-tab>
  <mat-tab label="File Uploader"></mat-tab>
</mat-tab-group>

<div [hidden]="currentTab !== 0" class="makequest-iframe">
  <iframe class="makequest-iframe__iframe"
    width="100%"
    [src]="embedUrl"
    frameborder="0"
    allowfullscreen
    allow="microphone *; camera *;"
    title="Make Quest iframe"
  ></iframe>
</div>
<div [hidden]="currentTab !== 1">
  <div fxLayout="row row-wrap" fxLayout.lt-md="column" fxLayoutAlign="start center">
    <div fxFlex="50" fxFlex.lt-md="100">
      <!-- TODO: get uploadSuccessCallback function in component ts file to fire once upload is completed in assignment-uploader ts file -->
      @if (!showUploads) {
        <app-assignment-uploader
          [hideUrlForm]="true"
          [imagesOnly]="true"
          [taskAssignmentData]="assignment"
          [apiUrl]="uploadPath"
          (uploadSuccess)="handleSuccess($event)"
          (fileSubmissionSet)="checkFileSubmission($event)"
        ></app-assignment-uploader>
      }
      <div class="text-align-center">
        <button
          mat-raised-button
          type="button"
          color="primary"
          [disabled]="isButtonDisabled"
          (click)="submitFiles()"
          >
          Upload File
        </button>
      </div>
    </div>
    <div fxFlex="50" fxFlex.lt-md="100">
      <h3 style="padding:20px;">My Assignment Uploads</h3>
      <assignment-uploads
        [apiUrl]="deletePath"
        [assignment]="assignment"
        (deleteSuccess)="handleSuccess($event)"
      ></assignment-uploads>
    </div>
  </div>
</div>
